/* import __COLOCATED_TEMPLATE__ from './penalties-card.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class PenaltiesCardComponent extends Component 
{		
	@service store;
}
